import { render, staticRenderFns } from "./PlayLogin2.vue?vue&type=template&id=16c3aec2&scoped=true&"
import script from "./PlayLogin2.vue?vue&type=script&lang=js&"
export * from "./PlayLogin2.vue?vue&type=script&lang=js&"
import style0 from "./PlayLogin2.vue?vue&type=style&index=0&id=16c3aec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3aec2",
  null
  
)

export default component.exports